// @flow
import window from 'window';

export class GlobalEventEmitterHandler {
	static emit = (
		eventEmitterName: string,
		eventName: string,
		model: any,
	) => new Promise((resolve, reject): Promise<any> => {
		if (!window[eventEmitterName]) {
			reject(new Error(`[${eventEmitterName}] doesn't exists in [window]`));
		}
		
		window[eventEmitterName].emit(
			eventName,
			model,
		);

		resolve();
	})
}